import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=5e87e42f&scoped=true&"
import script from "./modifyPwd.vue?vue&type=script&lang=js&"
export * from "./modifyPwd.vue?vue&type=script&lang=js&"
import style0 from "./modifyPwd.vue?vue&type=style&index=0&id=5e87e42f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87e42f",
  null
  
)

export default component.exports